import { CardContent, Button, CircularProgress } from '@material-ui/core'
import React, { Component } from 'react'
import { Card } from 'react-bootstrap'

class DialogoNominacionMultiple extends Component {
  render () {
    const { handleClose, isRequestingCupos } = this.props

    return (
      <div>
        <Card style={{ border: 'none' }}>
          <Card.Header style={{ backgroundColor: '#3f51b5', color: '#ffffff' }}>
            <Card.Text style={{ fontSize: '1.3rem', textAlign: 'center' }}>Nominación Múltiple</Card.Text>
          </Card.Header>
          <CardContent style={{ width: '85%', margin: '0 auto', textAlign: 'center' }}>
            {(isRequestingCupos)
              ? <h4>Procesando la nominación</h4>
              : <h4>La nominación de cupos fue generada correctamente</h4>
            }
            <br />
            {(isRequestingCupos)
              ? <div className='circular-progress-consulta-soap'>
                <CircularProgress thickness='5' size='5rem' style={{ margin: '0 auto' }} />
              </div>
              : <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Button
                  onClick={handleClose}
                  size='large'
                  color='primary'
                  variant='contained'
                >Continuar</Button>
              </div>}
          </CardContent>
        </Card>
      </div>
    )
  }
}

export default DialogoNominacionMultiple
